import {useEffect, useState} from 'react';

interface UserReadResponse {
  code: string;
  user?: {name?: string | null};
}

export interface CurrentUser {
  /** 是否已登录（code:'1000' 且返回 user 即视为登录，name 可能为空） */
  isLoggedIn: boolean;
  /** 用户昵称；已登录但后端未设置昵称时为 null */
  name: string | null;
}

/**
 * 探测当前浏览器是否已登录 workspace：营销站与 workspace 同域（www.xiangjifanyi.com），
 * 直接同源请求 /user/read 即可读到登录态，无需 CORS。登录态下返回 code:'1000' + user；
 * 本地开发环境（localhost）该接口不存在，请求会 404/失败，按未登录处理，不影响开发。
 * 失败静默吞掉——这只是导航栏的展示优化，不应该在未登录/接口不可用时报错或阻塞渲染。
 *
 * 注意：登录态与昵称分离——user.name 可能为 null/空串（已登录但未设置昵称），
 * 判断是否登录看 isLoggedIn，勿再按 name 真值推断（曾因此对已登录用户显示「登录」）。
 */
const useCurrentUser = (): CurrentUser => {
  const [user, setUser] = useState<CurrentUser>({isLoggedIn: false, name: null});

  useEffect(() => {
    let cancelled = false;

    fetch('/user/read?requestFrom=v2', {credentials: 'include'})
      .then((res) => (res.ok ? (res.json() as Promise<UserReadResponse>) : null))
      .then((data) => {
        if (!cancelled && data?.code === '1000' && data.user) {
          setUser({isLoggedIn: true, name: data.user.name || null});
        }
      })
      .catch(() => undefined);

    return () => {
      cancelled = true;
    };
  }, []);

  return user;
};

export default useCurrentUser;
